export const STYLE_PRESETS = [
  { value: 'informative', label: 'Informative', description: 'Historical facts and significance' },
  { value: 'storytelling', label: 'Storytelling', description: 'Narrative with human interest' },
  { value: 'concise', label: 'Concise', description: 'Maximum facts, minimum words' },
  { value: 'family-friendly', label: 'Family-Friendly', description: 'Accessible for all ages' },
];

export const AI_MODELS = [
  { value: 'gpt-4o-mini', label: 'GPT-4o Mini', description: 'Fast and cost-effective' },
  { value: 'gpt-5.2-2025-12-11', label: 'GPT-5.2', description: 'Latest and most capable' },
];
